import type OlMap from "ol/Map";
import type { Options as OverlayOptions } from "ol/Overlay";
import { useMemo } from "react";

import { useTranslation } from "../../../i18n";
import { MapOverlay } from "../../map-overlays/MapOverlay";

import "./MeasureTooltip.css";

export interface MeasureTooltipProps extends Pick<
  OverlayOptions,
  "offset" | "position"
> {
  map: OlMap;
  children?: React.ReactNode;
  staticMode?: boolean;
  onClose: () => void;
}

export function MeasureTooltip({
  map,
  offset = [0, -15],
  position,
  children,
  staticMode = false,
  onClose,
}: MeasureTooltipProps) {
  const { t } = useTranslation();
  const currentOffset = useMemo(
    () => (staticMode ? [0, -7] : offset),
    [offset, staticMode],
  );

  return (
    <MapOverlay map={map} offset={currentOffset} position={position}>
      <div
        className={
          staticMode
            ? "measure-tooltip measure-tooltip-static"
            : "measure-tooltip measure-tooltip-drawing"
        }
      >
        <span className="measure-tooltip-content">{children}</span>
        {staticMode && (
          <button
            className="measure-tooltip-close"
            type="button"
            aria-label={t("measure.close")}
            onClick={onClose}
          >
            <span className="measure-tooltip-close-icon" aria-hidden="true" />
          </button>
        )}
      </div>
    </MapOverlay>
  );
}
